import { render } from "./Charge.vue?vue&type=template&id=a1978cc6"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Charge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1978cc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1978cc6', __exports__)) {
    api.reload('a1978cc6', __exports__)
  }
  
  module.hot.accept("./Charge.vue?vue&type=template&id=a1978cc6", () => {
    api.rerender('a1978cc6', render)
  })

}


export default __exports__